import { Grid, Paper } from "@mui/material";

import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store";

import ThreeComponent from "../../../components/ThreeColumnsComponent";
import { IN_MY_CHARGE_EMPLOYEES_CONTRACTS_ONE, IN_MY_CHARGE_EMPLOYEES_CONTRACTS_TWO, IN_MY_CHARGE_EMPLOYEES_CONTRACTS_THREE } from "../../../constants/signalRequestConsts";
import { getEmployeesInMyCharge, getEmployeesToApprove } from "../../../api/s10OrganizationApi";
import { searchInMyChargeEmployeesContracts, setInMyChargeEmployeeContractsReset } from "../../../store/slices/userRequests";
import TableEmployeesContracts from "./TableEmployeesContracts";
import MySnackbar from "../../../components/MySnackbar";
import MySelectCompany from "../../../components/MySelectCompany";

// 0: todos los tipos de cupones
// -1: solo vacaciones sunat
// -2: todo menos vacaciones sunat
// viewType = All, InMyCharge, ToApprove

const EmployeesContracts = ({viewType}: {viewType: "All" | "InMyCharge" | "ToApprove"}) => {

    const dispatch = useDispatch<AppDispatch>();
    const {companyselected, connectionId} = useSelector((state: RootState) => state.auth);
    const [rucSelected, setRucSelected] = useState<string>("")
    const [errorMsg, setErrorMsg] = useState<string>("")

    const [employeesCodes, setEmployeesCodes] = useState<string | null>(null)
    const [descriptionOne, setDescriptionOne] = useState<string>("")
    const [descriptionTwo, setDescriptionTwo] = useState<string>("")
    const [descriptionThree, setDescriptionThree] = useState<string>("")
    const [pageSizeOne, setPageSizeOne] = useState<number>(25)
    const [pageSizeTwo, setPageSizeTwo] = useState<number>(25)
    const [pageSizeThree, setPageSizeThree] = useState<number>(25)
    const [pageOne, setPageOne] = useState<number>(2)
    const [pageTwo, setPageTwo] = useState<number>(2)
    const [pageThree, setPageThree] = useState<number>(2)
    
    // const [orderedEmployees, setOrderedEmployees] = useState<{ [key: string]: Employee[] }>({})

    useEffect(() => {
        if (!companyselected || !connectionId || !rucSelected) {
            return;
        }
        getInitialTablesData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rucSelected]);

    
    useEffect(() => {
        if (!companyselected || !connectionId || !rucSelected || employeesCodes === null) {
            return;
        }
        tableOneRequest();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [descriptionOne, pageSizeOne, pageOne, employeesCodes, rucSelected]);

    useEffect(() => {
        if (!companyselected || !connectionId || !rucSelected || employeesCodes === null) {
            return;
        }
        tableTwoRequest();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [descriptionTwo, pageSizeTwo, pageTwo, employeesCodes, rucSelected]);

    useEffect(() => {
        if (!companyselected || !connectionId || !rucSelected || employeesCodes === null) {
            return;
        }
        tableThreeRequest();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [descriptionThree, pageSizeThree, pageThree, employeesCodes, rucSelected]);

    const getInitialTablesData = async () => {

        let _employeesCodes =  "";
        dispatch(setInMyChargeEmployeeContractsReset(IN_MY_CHARGE_EMPLOYEES_CONTRACTS_ONE));
        dispatch(setInMyChargeEmployeeContractsReset(IN_MY_CHARGE_EMPLOYEES_CONTRACTS_TWO));
        dispatch(setInMyChargeEmployeeContractsReset(IN_MY_CHARGE_EMPLOYEES_CONTRACTS_THREE));
        const finalRuc = rucSelected === "all" ? "" : rucSelected;
        if (viewType === "InMyCharge") {
            const result = await getEmployeesInMyCharge(finalRuc);
            if (!result?.data?.length) {
                setErrorMsg("No posees personal asignado en el organigrama")
                return;
            }
            _employeesCodes = result?.data.join(",")
        } else if (viewType === "ToApprove") {
            const result = await getEmployeesToApprove();
            if (!result?.data?.length) {
                setErrorMsg("No posees personal asignado a tu grupo de aprobacion")
                return;
            }
            _employeesCodes = result?.data.join(",")
        }
        setEmployeesCodes(_employeesCodes);
    }

    const tableOneRequest = () => 
        dispatch(searchInMyChargeEmployeesContracts(
            IN_MY_CHARGE_EMPLOYEES_CONTRACTS_ONE,
            employeesCodes as any,
            rucSelected,
            1,
            descriptionOne,
            pageSizeOne,
            pageOne,
        ));

    const tableTwoRequest = () => 
        dispatch(searchInMyChargeEmployeesContracts(
            IN_MY_CHARGE_EMPLOYEES_CONTRACTS_TWO,
            employeesCodes as any,
            rucSelected,
            2,
            descriptionTwo,
            pageSizeTwo,
            pageTwo,
        ));

    const tableThreeRequest = () => 
        dispatch(searchInMyChargeEmployeesContracts(
            IN_MY_CHARGE_EMPLOYEES_CONTRACTS_THREE,
            employeesCodes as any,
            rucSelected,
            0,
            descriptionThree,
            pageSizeThree,
            pageThree,
            
        ));

    const ComponentOne = useCallback(() => (
        <TableEmployeesContracts
            requestId={IN_MY_CHARGE_EMPLOYEES_CONTRACTS_ONE}
            page={pageOne}
            setPage={setPageOne}
            description={descriptionOne}
            setDescription={setDescriptionOne}
            pageSize={pageSizeOne}
            setPageSize={setPageSizeOne}
        />
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ), []);
    const ComponentTwo = useCallback(() => (
        <TableEmployeesContracts
            requestId={IN_MY_CHARGE_EMPLOYEES_CONTRACTS_TWO}
            // hiddenFilterOptions={true}
            page={pageTwo}
            setPage={setPageTwo}
            description={descriptionTwo}
            setDescription={setDescriptionTwo}
            pageSize={pageSizeTwo}
            setPageSize={setPageSizeTwo}
        />
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ), []);
    const ComponentThree = useCallback(() => (
        <TableEmployeesContracts
            requestId={IN_MY_CHARGE_EMPLOYEES_CONTRACTS_THREE}
            page={pageThree}
            setPage={setPageThree}
            description={descriptionThree}
            setDescription={setDescriptionThree}
            pageSize={pageSizeThree}
            setPageSize={setPageSizeThree}
        />
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ), []);

    return (
    <Grid item width="100%" marginTop="1.5rem" minHeight="100%">
        <Paper
            elevation={3}
            style={{
                width: "100%", 
                borderRadius: "0.5rem",
                minHeight: "10rem",
                padding: "2rem 1.5rem"
            }}
        >
            
            <MySelectCompany 
                setRucSelected={setRucSelected} 
                rucSelected={rucSelected}
                includeAllCompaniesOption={true}
                allCompaniesOptionValue={'all'}
            />
            {/* {companiesData.length > 0 && <Grid item>
                <FormControl style={{minWidth: "15rem"}}>
                    <InputLabel id="select-option-label">Empresa</InputLabel>
                    <Select
                        labelId="select-option-label"
                        id="select-option"
                        label={"Empresa"}
                        onChange={(event: { target: { value: string } }) => {
                            const value = event.target.value;
                            setRucSelected(value);
                        }}
                        value={rucSelected}
                        style={{height: "2.5rem", border: "none", backgroundColor: "white"}}
                    >
                        {companiesData?.map((item, i) => (
                            <MenuItem
                                key={i} 
                                value={item.CompanyCode}
                            >
                                {item.Name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>} */}
            <ThreeComponent
                tabsTitle={["No firmados", "Observados", "Historico"]}
                useTabsNameAsTitle={true}
                ComponentOne={ComponentOne}
                ComponentTwo={ComponentTwo}
                ComponentThree={ComponentThree}
            />
        </Paper>
        {errorMsg && <MySnackbar
            msg={errorMsg}
            severity={"error"}
            open={!!errorMsg}
            onClose={() => {
                setErrorMsg("");
            }}
        />}
    </Grid>)
}

export default EmployeesContracts;